import { set, sortBy, map, reject } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchInventoryPackageOptions } from '../../../sagas/routines';
import {
  addPackageOption,
  updatePackageOption,
  removePackageOption
} from '../../../actions/options/package';

const composeOption = ({ id: value, name: label, price, weight, points }) => ({
  value,
  label,
  meta: { price, weight, points }
});

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchPackageOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const addOptionHandler = action => ({
  [action.toString()]: (state, { payload: item }) => ({
    ...state,
    all: sortBy('label', [...state.all, composeOption(item)])
  })
});

const updateOptionHandler = action => ({
  [action.toString()]: (state, { payload: item }) => ({
    ...state,
    all: map(
      option => (option.value === item.id ? composeOption(item) : option),
      state.all
    )
  })
});

const removeOptionHandler = action => ({
  [action.toString()]: (state, { payload: value }) => ({
    ...state,
    all: reject({ value }, state.all)
  })
});

export default createReducer(initialState, {
  ...fetchPackageOptionsHandler(fetchInventoryPackageOptions),
  ...addOptionHandler(addPackageOption),
  ...updateOptionHandler(updatePackageOption),
  ...removeOptionHandler(removePackageOption)
});
